/**
 * Join Query Array with a set delimiter
 * @param {Array} queryParams - The Array to check.
 * @returns {string | null} - Return string or null.
 */
export function ToQueryString(queryParams) {
     return queryParams && queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
}

/**
 * Join Query Array with a set delimiter
 * @param {String} str - The Array to check.
 * @param {String} delimiter - The Array to check.
 * @returns {Array | null} - Return Array or null.
 */
export function toArray(str, delimiter = ",") {
    if (!str) return null;

    return str.split(delimiter) || null;
}

/**
 * Checks if Array is not null and contains any Items
 * @param {Array | null} array - The Array to check.
 * @returns {Boolean} - Return Boolean.
 */
export function hasAny (array) {
    if (!array) return false;

    return (array?.length > 0);
}